import React from "react";
import { cn } from "../utils/cn";

export interface SelectOption {
  value: string;
  label: string;
}

export interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  options: SelectOption[];
  placeholder?: string;
}

export const Select = React.forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, label, error, options, placeholder, ...props }, ref) => {
    return (
      <div className="w-full">
        {label && (
          <label className="block text-sm font-bold text-juridico mb-2">
            {label}
          </label>
        )}
        <select
          className={cn(
            "w-full px-4 py-3 border outline-none border-tiber-200 rounded-lg focus:ring-2",
            "focus:ring-tiber-600 focus:border-transparent bg-romance-50",
            "disabled:bg-tiber-100 disabled:cursor-not-allowed",
            error ? "border-red-500 focus:ring-red-500" : "border-tiber",
            className,
          )}
          ref={ref}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
      </div>
    );
  },
);

Select.displayName = "Select";
